import React, { useEffect, useState } from 'react';

const affirmationData = [
  { text: "You are the calm in someone’s chaos.", mood: "calm" },
  { text: "Your voice is a lifeline — never forget your impact.", mood: "support" },
  { text: "You help people through the worst moments of their lives.", mood: "hero" },
  { text: "You are doing more than answering calls — you're answering prayers.", mood: "hero" },
  { text: "You make quick decisions that save lives every day.", mood: "focus" },
  { text: "Your strength behind the scenes is felt in every emergency.", mood: "support" },
  { text: "You were chosen for this mission. You are built for this.", mood: "hero" },
  { text: "Every moment you stay steady brings someone hope.", mood: "calm" },
  { text: "You are not alone — you are supported, seen, and appreciated.", mood: "support" },
  { text: "Courage doesn’t always wear a uniform — sometimes, it wears a headset.", mood: "hero" },
];

// Mood-to-style mapping
const moodStyles = {
  calm: {
    background: 'linear-gradient(to right, #c2e9fb, #a1c4fd)',
    color: '#003366',
    icon: '🕊️',
  },
  hero: {
    background: 'linear-gradient(to right, #f83600, #f9d423)',
    color: '#2c2c2c',
    icon: '🛡️',
  },
  support: {
    background: 'linear-gradient(to right, #fbc2eb, #a6c1ee)',
    color: '#3b3b3b',
    icon: '🤝',
  },
  focus: {
    background: 'linear-gradient(to right, #4facfe, #00f2fe)',
    color: '#001f33',
    icon: '🎯',
  }
};

const AffirmationBanner = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % affirmationData.length);
    }, 9110); // every 9.11 seconds

    return () => clearInterval(interval);
  }, []);

  const current = affirmationData[index];
  const style = moodStyles[current.mood] || {};

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      padding: '1rem',
      background: style.background || '#f5f5f5',
      color: style.color || '#1a1a1a',
      fontWeight: '600',
      fontSize: '1.1rem',
      textAlign: 'center',
      borderBottom: '2px solid #ccc',
      boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
      zIndex: 9999,
      fontFamily: 'system-ui, sans-serif',
      letterSpacing: '0.4px'
    }}>
      <span style={{ marginRight: 8 }}>{style.icon}</span>
      {current.text}
    </div>
  );
};

export default AffirmationBanner;


